import { Component, Optional, Inject, Injector, forwardRef, Input, Output, EventEmitter, AfterViewChecked, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';

import { Observable } from 'rxjs';

import { SelectOption } from '../../../common';
import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-combobox',
    templateUrl: './input-combobox.component.html',
    styleUrls: [
        '../input.component.scss',
        './input-combobox.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputComboboxComponent),
            multi: true,
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputComboboxComponent extends InputBase<string> implements AfterViewChecked
{
    private static identifier: number = 0;
    public fieldId: string = `input-combobox-${InputComboboxComponent.identifier++}-id`;
    public formGroup: UntypedFormGroup;
    @Input() items: Observable<SelectOption[]>;
    @Input() placeholder: string = '';
    @Output() select: EventEmitter<string> = new EventEmitter<string>();

    constructor (
        injector: Injector,
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        private cdRef: ChangeDetectorRef
    )
    {
        super(injector);

        this.formGroup = new UntypedFormGroup(
            {
                formControlName: new UntypedFormControl('', Validators.required)
            });
    }

    ngAfterViewChecked ()
    {
        this.formGroup.get('formControlName').setValue(this.value);
        this.cdRef.detectChanges();
    }

    onSelected ()
    {
        this.value = this.formGroup.get('formControlName').value;
        this.select.emit(this.value);
    }
}
